export default class ToInvoiceDefaultState{
  loading = false;
  total = 0;
  count = 0;
  mergeInvoicesCount = 0;
  mergeInvoicesTotal = 0;
}
